import fetchServer from "../fetchServer";

export default async function sendEmailToCustomer({ data, setLoading }) {
  setLoading?.(true);
  let result = {
    return: 0,
    msg: "Something went wrong fetching booking!",
  };

  await fetchServer({
    method: "POST",
    url: `/notification/v2/mail/generic`,
    data,
  })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = { return: 1, msg: "Successful", data: res?.data?.data };
      } else if (res?.data?.error) result["msg"] = res.data.error;
    })
    .catch((err) => {
      console.log("Network Error!");
    })
    .finally(() => setLoading?.(false));

  return result;
}
